/**
 * Program Card Component
 * Displays a program/class in a card format
 */

import styles from './ProgramCard.module.css';
import { Button } from '../Button/Button.js';

export class ProgramCard {
  constructor({ title, description, ageGroup, image, href, featured = false }) {
    this.title = title;
    this.description = description;
    this.ageGroup = ageGroup;
    this.image = image;
    this.href = href;
    this.featured = featured;
  }

  render() {
    const card = document.createElement('article');
    card.className = `${styles.card} ${this.featured ? styles.featured : ''}`;

    // Image
    if (this.image) {
      const imageWrapper = document.createElement('div');
      imageWrapper.className = styles.imageWrapper;
      
      const img = document.createElement('img');
      img.src = this.image;
      img.alt = this.title;
      img.loading = 'lazy';
      
      imageWrapper.appendChild(img);
      card.appendChild(imageWrapper);
    }

    // Content
    const content = document.createElement('div');
    content.className = styles.content;

    if (this.ageGroup) {
      const ageBadge = document.createElement('span');
      ageBadge.className = styles.ageBadge;
      ageBadge.textContent = this.ageGroup;
      content.appendChild(ageBadge);
    }

    const title = document.createElement('h3');
    title.className = styles.title;
    title.textContent = this.title;
    content.appendChild(title);

    if (this.description) {
      const description = document.createElement('p');
      description.className = styles.description;
      description.textContent = this.description;
      content.appendChild(description);
    }

    if (this.href) {
      const button = new Button({
        text: 'Learn More',
        href: this.href,
        variant: 'secondary'
      });
      content.appendChild(button.render());
    }

    card.appendChild(content);
    return card;
  }
}
